import client from './internal/httpClient';

export const listTlds  = ()     => client.get('/admin/tlds/list');
export const saveTld   = (data) => client.post('/admin/tlds/save', data);
export const deleteTld = (tld)  => client.post('/admin/tlds/delete', { tld });
